import script from "./FormInput.vue?vue&type=script&lang=ts&setup=true"
export * from "./FormInput.vue?vue&type=script&lang=ts&setup=true"

import "./FormInput.vue?vue&type=style&index=0&id=019cdf30&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-019cdf30"]])

export default __exports__